import { AxiosError, AxiosResponse } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { createOauthAccessToken } from '@/support/Clients/OauthClient';
import Token from '@/support/Token';
import { User } from '@/models/User';
import { Application } from '@/support/Application';

@Component<App>({ })
export default class App extends Vue {
  protected $pageTitle = 'Login';

  protected error: string | null = null;

  protected isLoading = false;

  protected async mounted(): Promise<void> {
    this.isLoading = true;
    if (Token.get('access') && ! this.$store.getters.user) {
      await new User()
        .current()
        .then(() => {
          this.$router.push('/dashboard');
        })
        .catch(() => {
          Token.delete(['access', 'refresh']);

          this.isLoading = false;
        });
    } else if (Token.get('access') && this.$store.getters.user) {
      this.$router.push('/dashboard');
    } else {
      this.isLoading = false;
    }
  }

  public async onClickSubmit(data: LoginFormData): Promise<void> {
    this.error = null;
    this.isLoading = true;

    createOauthAccessToken({
      username: data.email,
      password: data.password,
      token: data.token,
    }).then(async (oAuthResponse): Promise<void> => {
      if (oAuthResponse.status !== 200) {
        this.isLoading = false;
        this.error = 'Invalid Credentials';
        return;
      }

      if (oAuthResponse.data.access_token) {
        this.fetchUser(oAuthResponse);
      }
    }).catch(() => {
      this.error = 'Invalid Credentials';
      this.isLoading = false;
    });
  }

  protected fetchUser(oAuthResponse: AxiosResponse) {
    Token.delete(['access', 'refresh']);
    Token.set({ access: oAuthResponse.data.access_token, refresh: oAuthResponse.data.refresh_token });
    new User()
      .current()
      .then((user: User) => {
      // hin check
        if (! user.has_hin) {
          this.error = 'Invalid Credentials';
          this.isLoading = false;
          return;
        }

        this.$router.push('/dashboard');
      })
      .catch((error: AxiosError) => {
        Token.delete(['access', 'refresh']);
      });
  }

  protected get isAcceptance() {
    return Application.config('APP_ENV') === 'acceptance';
  }
}

interface LoginFormData {
  email: string;
  password: string;
  token: string;
}
